import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-up', 'ChevronUp', [["path",{"d":"M6 15l6 -6l6 6"}]]);